/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Remove_Tool_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Remove this tool?" |
*
* @param {Rights_Tools_Remove_Tool_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_remove_tool_confirm_title = /** @type {((inputs?: Rights_Tools_Remove_Tool_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Remove_Tool_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Tool entfernen?")
	return /** @type {LocalizedString} */ ("Remove this tool?")
});